import React from "react";
import NewCountrySettingContent from "../components/countrySettings/new-countrySetting-content";

const NewCountrySetting = () => {
  return <NewCountrySettingContent />;
};

export default NewCountrySetting;
